import { Button, type ButtonProps } from "antd";
import clsx from "clsx";
import "./AppButton.scss";

export type AppButtonTone =
  | "default"
  | "primary"
  | "secondary"
  | "success"
  | "danger"
  | "warning"
  | "info"
  | "light"
  | "dark"
  | "ghost";

export type AppButtonProps = ButtonProps & {
  tone?: AppButtonTone;
  rounded?: boolean;
};

export const AppButton = ({
  className,
  tone = "default",
  rounded,
  ...props
}: AppButtonProps) => {
  return (
    <Button
      className={clsx(
        "app-ant-btn",
        `app-ant-btn-${tone}`,
        rounded && "app-ant-btn-rounded",
        className,
      )}
      {...props}
    />
  );
};
